import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { UserAddView } from '@/modules/users'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/users/add/')({
  component: UserAddView,
  head: () =>
    getMetaWithPageTitle([i18n.t('title.add-new-user', { ns: 'users' })])
})
